import { render } from "./Home.vue?vue&type=template&id=4ba36cb8"
const script = {}

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__